import * as React from "react";
import { Box } from "@mui/material";
import { ThemeProperties } from "../../../../../Theme/ThemeProperties";
import { StyledTabContainer, TertiaryTab } from "../../../../../Components/CustomTab";

export default function ComparisonTabs({
    tabs = [],
    selectedTab,
    changeTheTab = () => { },
}) {
    const [currentTab, setCurrentTab] = React.useState(selectedTab);

    const handleChange = (event, newValue) => {
        setCurrentTab(newValue);
        changeTheTab(newValue);
    };

    React.useEffect(() => {
        setCurrentTab(selectedTab);
    }, [selectedTab]);


    return (
        <Box sx={{
            background: '#F9F9F9',
            borderRadius: '8px',
            minHeight: 0
        }}>
            <StyledTabContainer
                value={currentTab}
                onChange={handleChange}
                aria-label="Tertiary tabs"
                elevation={1}
                sx={{ minHeight: 0, display: 'flex', width: '100%' }}
                myColor={ThemeProperties.purple}>


                {tabs.map((item) => (
                    <TertiaryTab disabled={item.disabled} isActive={selectedTab == item.slug} value={item.slug} key={item.id} label={item.name} />
                ))
                }
            </StyledTabContainer >
        </Box >
    );
}
